import { string } from "prop-types";
import reSourceService from "../ResourceService";
const urlEndpoint = "authenticate";
interface Menu {
  Id: number;
  TenChucNang: string;
  ThuTu: number;
  LienKet: string;
  DoHoaDeThuong: string;
  childMenu: Menu[];
}
//MENU Quản lý giảng đường tĩnh
//SV
const MENU_SV: Menu[] = [
  {
    Id: 0,
    TenChucNang: "Trang cá nhân",
    ThuTu: 0,
    LienKet: "",
    DoHoaDeThuong: "User",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Trang cá nhân",
        ThuTu: 0,
        LienKet: "/student/info",
        DoHoaDeThuong: "User",
        childMenu: null,
      },
    ],
  },
  {
    Id: 1,
    TenChucNang: "Chức năng trực tuyến",
    ThuTu: 2,
    LienKet: "",
    DoHoaDeThuong: "ClipboardList",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Mượn phòng",
        ThuTu: 0,
        LienKet: "/student/MuonPhong",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
    ],
  },
];
//GV
const MENU_GV: Menu[] = [
  {
    Id: 0,
    TenChucNang: "Trang cá nhân",
    ThuTu: 0,
    LienKet: "",
    DoHoaDeThuong: "User",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Trang cá nhân",
        ThuTu: 0,
        LienKet: "/professor/info",
        DoHoaDeThuong: "User",
        childMenu: null,
      },
    ],
  },
  {
    Id: 1,
    TenChucNang: "Chức năng trực tuyến",
    ThuTu: 2,
    LienKet: "",
    DoHoaDeThuong: "ClipboardList",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Mượn phòng",
        ThuTu: 0,
        LienKet: "/professor/MuonPhong",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
      {
        Id: 1,
        TenChucNang: "Báo nghỉ báo bù",
        ThuTu: 1,
        LienKet: "/professor/BaoNghiBaoBu",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
    ],
  },
];
//AD
const MENU_AD: Menu[] = [
  {
    Id: 2,
    TenChucNang: "Cấu hình chức năng",
    ThuTu: 0,
    LienKet: "",
    DoHoaDeThuong: "ClipboardList",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Thêm chức năng",
        ThuTu: 0,
        LienKet: "/staff/phanquyen",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
      {
        Id: 1,
        TenChucNang: "Phân quyền cho nhóm",
        ThuTu: 0,
        LienKet: "/staff/nhomquyen",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
      {
        Id: 2,
        TenChucNang: "Chức năng",
        ThuTu: 0,
        LienKet: "/staff/chucnang",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
      {
        Id: 4,
        TenChucNang: "Phân quyền nhân viên",
        ThuTu: 0,
        LienKet: "/staff/phanquyennhanvien",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
    ],
  },
  {
    Id: 0,
    TenChucNang: "Chức năng trực tuyến",
    ThuTu: 0,
    LienKet: "",
    DoHoaDeThuong: "ClipboardList",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Duyệt mượn phòng, cấp phòng",
        ThuTu: 0,
        LienKet: "/staff/DuyetPhong",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
      {
        Id: 1,
        TenChucNang: "Liên kết",
        ThuTu: 1,
        LienKet: "/staff/HeaderMenus",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
      {
        Id: 2,
        TenChucNang: "Quản lý Menu",
        ThuTu: 2,
        LienKet: "/staff/Menu",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
    ],
  },
  {
    Id: 1,
    TenChucNang: "Quản lý ngôn ngữ",
    ThuTu: 0,
    LienKet: "",
    DoHoaDeThuong: "ClipboardList",
    childMenu: [
      {
        Id: 0,
        TenChucNang: "Quản lý ngôn ngữ",
        ThuTu: 0,
        LienKet: "/staff/Language",
        DoHoaDeThuong: "ClipboardList",
        childMenu: null,
      },
    ],
  },
];
const menuService = {
  GetMenu: (language?: string): Promise<Menu[] | null> => {
    return reSourceService.get(`${urlEndpoint}/getmenu?language=${language}`);
  },
  GetMenuQLGD: (type: string): Promise<Menu[] | null> => {
    switch (type) {
      case "SV":
        return Promise.resolve(MENU_SV as Menu[]);
        break;
      case "GV":
        return Promise.resolve(MENU_GV as Menu[]);
        break;
      case "AD":
        return Promise.resolve(MENU_AD as Menu[]);
        break;
      default:
        return Promise.resolve([] as Menu[]);
        break;
    }
    // return reSourceService.get(`${urlEndpoint}/getmenu?language=${language}`);
  },
};
export default menuService;
